import { render, staticRenderFns } from "./Asset-currency-chart.vue?vue&type=template&id=70f62fb4&"
import script from "./Asset-currency-chart.vue?vue&type=script&lang=js&"
export * from "./Asset-currency-chart.vue?vue&type=script&lang=js&"
import style0 from "./Asset-currency-chart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports